import { Translation } from '@ps/web-shared-components';

import BritishPoundIcon from '../../../assets/icons/currencies/british-pound.svg';
import CanadianDollarIcon from '../../../assets/icons/currencies/canadian-dollar.svg';
import DollarIcon from '../../../assets/icons/currencies/dollar.svg';
import EuroIcon from '../../../assets/icons/currencies/euro.svg';
import type { IconsLegendData } from '../IconGroupLegend';
import IconGroupLegend from '../IconGroupLegend';

import {
  TXTCLI_CurrTitle_CAD,
  TXTCLI_CurrTitle_EUR,
  TXTCLI_CurrTitle_GBP,
  TXTCLI_CurrTitle_USD,
  TXTCLI_Currencies
} from './CurrencyIconLegend.messages.json';

const currencyConfig: IconsLegendData[] = [
  {
    Icon: <EuroIcon />,
    Description: <Translation tagName="span" {...TXTCLI_CurrTitle_EUR} />
  },
  {
    Icon: <BritishPoundIcon />,
    Description: <Translation tagName="span" {...TXTCLI_CurrTitle_GBP} />
  },
  {
    Icon: <DollarIcon />,
    Description: <Translation tagName="span" {...TXTCLI_CurrTitle_USD} />
  },
  {
    Icon: <CanadianDollarIcon />,
    Description: <Translation tagName="span" {...TXTCLI_CurrTitle_CAD} />
  }
];

const CurrencyIconLegend: React.FC = () => (
  <IconGroupLegend data={currencyConfig} title={<Translation {...TXTCLI_Currencies} />} />
);

export default CurrencyIconLegend;
